"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var redux_1 = require("redux");
var reducers_1 = require("./betting/reducers");
var reducers_2 = require("./amount/reducers");
var reducers_3 = require("./challenges/reducers");
var reducers_4 = require("./name/reducers");
var reducers_5 = require("./animation-playing/reducers");
exports.rootReducer = redux_1.combineReducers({
    bet: reducers_1.betReducer,
    amount: reducers_2.amountReducer,
    challenge: reducers_3.challengeReducer,
    name: reducers_4.nameReducer,
    animationPlay: reducers_5.animationPlayReducer
});



//////////////////
// WEBPACK FOOTER
// ./src/games/fast-coin/ts/store/index.ts
// module id = 2410
// module chunks = 5